/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.6.0-nightly.2026.8.22",
    versionName: "0.6.0-nightly.2026.8.22",
    versionChannel: "nightly",
    buildDate: "2026-08-22T00:10:18.250Z",
    commitHash: "d1c3c14a2cbf6e6e64e288cac9d9a9ae0ef01a42",
};
